
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("6jBAp"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("6jBAp", function(module, exports) {

let $4991ac44e590d12e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4991ac44e590d12e$var$load("h3ABO"),
    $4991ac44e590d12e$var$load("3Tca0"),
    $4991ac44e590d12e$var$load("2fH0a"),
    $4991ac44e590d12e$var$load("OkWBV"),
    $4991ac44e590d12e$var$load("4jlMu"),
    $4991ac44e590d12e$var$load("2YffH"),
    $4991ac44e590d12e$var$load("2VmDq"),
    $4991ac44e590d12e$var$load("g7ggm"),
    $4991ac44e590d12e$var$load("6mHrv"),
    $4991ac44e590d12e$var$load("awWN9"),
    $4991ac44e590d12e$var$load("9CYct"),
    $4991ac44e590d12e$var$load("52GaU"),
    $4991ac44e590d12e$var$load("lRtQk"),
    $4991ac44e590d12e$var$load("hZtKG"),
    $4991ac44e590d12e$var$load("dkqvW"),
    $4991ac44e590d12e$var$load("lVO3w"),
    $4991ac44e590d12e$var$load("hyzoX"),
    $4991ac44e590d12e$var$load("h9Ed7"),
    $4991ac44e590d12e$var$load("eBRUf"),
    $4991ac44e590d12e$var$load("kbRvk"),
    $4991ac44e590d12e$var$load("tKhaz"),
    $4991ac44e590d12e$var$load("9Vh0G"),
    $4991ac44e590d12e$var$load("hBIgN"),
    $4991ac44e590d12e$var$load("cD6Zr"),
    $4991ac44e590d12e$var$load("k3jER"),
    $4991ac44e590d12e$var$load("9wzNh"),
    $4991ac44e590d12e$var$load("8YSo7"),
    $4991ac44e590d12e$var$load("9ldRJ"),
    $4991ac44e590d12e$var$load("50ame"),
    $4991ac44e590d12e$var$load("e7ZUf"),
    $4991ac44e590d12e$var$load("gL8bn"),
    $4991ac44e590d12e$var$load("1MlIV"),
    $4991ac44e590d12e$var$load("6iz6l"),
    $4991ac44e590d12e$var$load("4SCW2"),
    $4991ac44e590d12e$var$load("8bXcu"),
    $4991ac44e590d12e$var$load("1YiFu"),
    $4991ac44e590d12e$var$load("hv4mn"),
    $4991ac44e590d12e$var$load("Wowvf"),
    $4991ac44e590d12e$var$load("dek7I"),
    $4991ac44e590d12e$var$load("dYtBN"),
    $4991ac44e590d12e$var$load("6wr18"),
    $4991ac44e590d12e$var$load("kjZZD"),
    $4991ac44e590d12e$var$load("jytCl"),
    $4991ac44e590d12e$var$load("iGhIB"),
    $4991ac44e590d12e$var$load("3JSgG"),
    $4991ac44e590d12e$var$load("37ldp"),
    $4991ac44e590d12e$var$load("ffEVr"),
    $4991ac44e590d12e$var$load("9AXkC"),
    $4991ac44e590d12e$var$load("28arV"),
    $4991ac44e590d12e$var$load("hhss7"),
    $4991ac44e590d12e$var$load("jYUNl"),
    $4991ac44e590d12e$var$load("foy8I"),
    $4991ac44e590d12e$var$load("f1Pmi"),
    $4991ac44e590d12e$var$load("dP7ao"),
    $4991ac44e590d12e$var$load("hogcU"),
    $4991ac44e590d12e$var$load("5vfHd"),
    $4991ac44e590d12e$var$load("2Stk7"),
    $4991ac44e590d12e$var$load("7EorR"),
    $4991ac44e590d12e$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.3b6f81a7.js.map
